// extracted by mini-css-extract-plugin
module.exports = {"back":"back-link_back__kAIe_","icon":"back-link_icon__0FZx_"};